<template>
  <div class="maintenance-root">
    <div class="maintenance-card">
      <div class="maintenance-brand">misepis</div>
      <h1 class="maintenance-title">Portal en mantenimiento</h1>
      <p class="maintenance-text">
        Estamos realizando tareas de mejora. El acceso al panel quedará deshabilitado temporalmente.
      </p>
      <p class="maintenance-sub">
        Por favor, inténtalo de nuevo más tarde. Si necesitas urgencia operativa, contacta con soporte.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "MaintenancePage",
};
</script>

<style scoped>
.maintenance-root {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: linear-gradient(180deg, #eef2f7 0%, #e8ecf2 50%, #e4e9f0 100%);
  color: #1e293b;
  font-family: "Open Sans", "Helvetica Neue", Arial, sans-serif;
}

.maintenance-card {
  max-width: 520px;
  text-align: center;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  padding: 2.5rem 2rem;
  box-shadow:
    0 1px 3px rgba(15, 23, 42, 0.06),
    0 12px 28px rgba(15, 23, 42, 0.08);
}

.maintenance-brand {
  font-size: 1.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-bottom: 1.5rem;
  color: #4f46e5;
}

.maintenance-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 1rem;
  line-height: 1.35;
  color: #0f172a;
}

.maintenance-text {
  font-size: 1rem;
  line-height: 1.55;
  margin: 0 0 1rem;
  color: #334155;
}

.maintenance-sub {
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0;
  color: #64748b;
}
</style>
